import { MappedTable } from "#selectors";
import { AppDispatch } from "#store/types";
import {
    CellContextMenuItemWithTable,
    ColumnContextMenuItemWithTable,
    MteCellEventWithTable,
    MteColumnEventWithTable,
    RowContextMenuItemWithTable,
    TableContextMenuItemWithTable,
} from "@inode/multi-table-explorer";
import { Interpretation } from "@inode/pilot-client-typescript-fetch";
import { setInterpretationFav, toggleColumnFav } from "#store/ui";
import * as Logging from "#store/logging";
import {
    triggerExploreByFacet,
    triggerExploreByFilter,
    triggerExploreByNl,
    triggerExploreBySuperset,
    triggerGiveFeedback,
    triggerRecommendations,
} from "#store/actions";
import { IQueryTableResult } from "#services/pilotService/responses/types";
import { FeedbackData } from "#store/tables";
import { push } from "redux-first-history";
import { generateUrl } from "#components/App/routing/generateUrl";
import { generatePath } from "react-router";
import { Routes } from "#/config";
import { ActionType, DatasourceEnum } from "#services/pilotService/types";

export function generateCellContextMenu(
    mappedTables: MappedTable[],
    dispatch: AppDispatch
) {
    const cellContextMenu: CellContextMenuItemWithTable[] = [
        {
            label: "Explore by filter",
            action: (evt: MteCellEventWithTable) => {
                const sql: string = mappedTables[evt.table].table.sourceQuery;
                dispatch(
                    Logging.log("click/by-filter-context-menu-option", {
                        sql: sql,
                        column: evt.column,
                        value: evt.value,
                    })
                );
                dispatch(
                    push(
                        generateUrl(generatePath(Routes.triggerAction.path), {
                            q: sql,
                            op: ActionType.QL_FILTER,
                            column: evt.column,
                            value: JSON.stringify(String(evt.value)),
                            operator: "=",
                        })
                    )
                );
                // dispatch(
                //     triggerExploreByFilter({
                //         query: sql,
                //         column: evt.column,
                //         value: String(evt.value),
                //         operator: "=",
                //     })
                // );
            },
        },
    ];
    return cellContextMenu;
}

export function generateColumnContextMenu(
    mappedTables: MappedTable[],
    dispatch: AppDispatch,
    handleCollapse: (column: string, collapseCluster: boolean) => void
) {
    const columContextMenu: ColumnContextMenuItemWithTable[] = [
        {
            label: "Explore by facet",
            action: (evt: MteColumnEventWithTable) => {
                const sql: string = mappedTables[evt.table].table.sourceQuery;
                const cols: string[] = [evt.column];
                // dispatch(triggerExploreByFacet(sql, cols));
                dispatch(
                    Logging.log("click/by-facet-context-menu-option", {
                        sql: sql,
                        columns: cols,
                    })
                );
                dispatch(
                    push(
                        generateUrl(generatePath(Routes.triggerAction.path), {
                            q: sql,
                            op: ActionType.QL_FACET,
                            column: evt.column,
                        })
                    )
                );
            },
        },
        {
            label: "Favorite Column",
            action: (evt: MteColumnEventWithTable) => {
                dispatch(toggleColumnFav(evt.column));
            },
        },
        {
            label: "Collapse Column",
            action: (evt: MteColumnEventWithTable) => {
                handleCollapse(evt.column, false);
            },
        },
        {
            label: "Collapse Column Group",
            action: (evt: MteColumnEventWithTable) => {
                handleCollapse(evt.column, true);
            },
        },
    ];
    return columContextMenu;
}

export function generateRowContextMenu(
    mappedTables: MappedTable[],
    dispatch: AppDispatch
): RowContextMenuItemWithTable[] {
    return [
        {
            label: "row context item 1",
            action: evt => {
                console.log("action triggered on row 1", evt);
            },
        },
        {
            label: "row context item 2",
            action: evt => {
                console.log("action triggered on row 2", evt);
            },
        },
    ];
}

export function generateTableContextMenu(
    dispatch: AppDispatch,
    interpretations: Interpretation[],
    mappedTables: MappedTable[]
): TableContextMenuItemWithTable[] {
    return [
        {
            label: "Show in detail",
            action: evt => {
                console.log(
                    "show details",
                    mappedTables[evt.table].table.interpretationId
                );
                dispatch(
                    push(
                        generatePath(Routes.interpretation.path, {
                            id: String(
                                mappedTables[evt.table].table.interpretationId
                            ),
                        })
                    )
                );
            },
        },
        {
            label: "Remove from cart",
            action: evt => {
                dispatch(
                    setInterpretationFav(
                        interpretations[
                            mappedTables[evt.table].interpretationIdx
                        ].id,
                        false
                    )
                );
            },
        },
        // {
        //     label: "Explore by overlap",
        //     action: (evt) => {
        //         const sql: string = tables[evt.table].sql;
        //         dispatch(Logging.log("click/by-overlap-context-menu-option",{sql: sql});
        //         this.fhgDataService.triggerExploreByOverlap(sql));
        //     }
        // },
        {
            label: "Explore by superset",
            action: evt => {
                const sql: string = mappedTables[evt.table].table.sourceQuery;
                dispatch(
                    Logging.log("click/by-superset-context-menu-option", {
                        sql: sql,
                    })
                );
                dispatch(
                    push(
                        generateUrl(generatePath(Routes.triggerAction.path), {
                            q: sql,
                            op: ActionType.QL_SUPERSET,
                        })
                    )
                );
            },
        },
        {
            label: "Explore by recommendation",
            action: evt => {
                const table: IQueryTableResult = mappedTables[evt.table].table;
                const sql: string = table.sourceQuery;
                dispatch(
                    Logging.log("click/by-recommendation-context-menu-option", {
                        sql: sql,
                    })
                );
                // dispatch(
                //     triggerRecommendations(
                //         sql,
                //         table.columns,
                //         table.meta.weigths
                //     )
                // );
                dispatch(
                    push(
                        generateUrl(generatePath(Routes.triggerAction.path), {
                            q: sql,
                            op: ActionType.BY_RECOMMENDATION,
                        })
                    )
                );
            },
        },
        // {
        //     label: "Explore by natural language",
        //     action: evt => {
        //         const nlQuery: string = mappedTables[evt.table].table.meta[
        //             "explanation"
        //         ] as string;
        //         dispatch(
        //             Logging.log("click/by-nl-context-menu-option", {
        //                 query: nlQuery,
        //             })
        //         );
        //         dispatch(
        //             triggerExploreByNl({
        //                 query: nlQuery,
        //             })
        //         );
        //     },
        // },
        // {
        //     label: "Give feedback",
        //     action: evt => {
        //         const table: IQueryTableResult = mappedTables[evt.table].table;
        //         dispatch(
        //             Logging.log("click/feedback-context-menu-option", {
        //                 sql: table.sourceQuery,
        //                 interpretationOf: table.meta["interpretationOf"],
        //             })
        //         );
        //         const feedback: string = table.meta["feedback"] as string;
        //         const previouslySavedFeedback: FeedbackData = {
        //             tableIndex: evt.table,
        //             feedback: feedback ? feedback : "",
        //         };
        //         dispatch(triggerGiveFeedback(previouslySavedFeedback));
        //     },
        // },
    ];
}

export function generateInterpretationCellContextMenu(
    mappedTables: MappedTable[],
    dispatch: AppDispatch,
    datasource: DatasourceEnum
) {
    const cellContextMenu: CellContextMenuItemWithTable[] = [
        {
            label: "Explore by filter",
            action: (evt: MteCellEventWithTable) => {
                const sql: string = mappedTables[evt.table].table.sourceQuery;
                dispatch(
                    Logging.log("click/by-filter-context-menu-option", {
                        sql: sql,
                        column: evt.column,
                        value: evt.value,
                    })
                );
                dispatch(
                    push(
                        generateUrl(generatePath(Routes.triggerAction.path), {
                            q: sql,
                            op: ActionType.QL_FILTER,
                            column: evt.column,
                            value: JSON.stringify(String(evt.value)),
                            operator: "=",
                            db: datasource,
                        })
                    )
                );
            },
        },
    ];
    return cellContextMenu;
}

export function generateInterpretationColumnContextMenu(
    mappedTables: MappedTable[],
    dispatch: AppDispatch,
    datasource: DatasourceEnum
) {
    const columContextMenu: ColumnContextMenuItemWithTable[] = [
        {
            label: "Explore by facet",
            action: (evt: MteColumnEventWithTable) => {
                const sql: string = mappedTables[evt.table].table.sourceQuery;
                const cols: string[] = [evt.column];
                dispatch(
                    Logging.log("click/by-facet-context-menu-option", {
                        sql: sql,
                        columns: cols,
                    })
                );
                dispatch(
                    push(
                        generateUrl(generatePath(Routes.triggerAction.path), {
                            q: sql,
                            op: ActionType.QL_FACET,
                            column: evt.column,
                            db: datasource,
                        })
                    )
                );
            },
        },
    ];
    return columContextMenu;
}

export function generateInterpretationTableContextMenu(
    mappedTables: MappedTable[],
    dispatch: AppDispatch,
    datasource: DatasourceEnum
): TableContextMenuItemWithTable[] {
    return [
        {
            label: "Explore by superset",
            action: evt => {
                const sql: string = mappedTables[evt.table].table.sourceQuery;
                dispatch(
                    Logging.log("click/by-superset-context-menu-option", {
                        sql: sql,
                    })
                );
                dispatch(
                    push(
                        generateUrl(generatePath(Routes.triggerAction.path), {
                            q: sql,
                            op: ActionType.QL_SUPERSET,
                            db: datasource,
                        })
                    )
                );
            },
        },
    ];
}
